import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "NewSupportTicketMessage" })
export default class NewSupportTicketMessage extends Vue {
    public localizer: any = Localizer;
    public isLoading: boolean = false;
    public isEdit: boolean = false;
    public isSuccess: boolean = false;
    public formData: any = { topic: null };
    public messageFileName: string = null;
    public validationErrors: any[] = [];

    @Prop() readonly supportTicketCode: string;

    get routes() {
        return (<any>window).App.routes;
    }

    public setMessageFileName() {
        let messageFile = (<any>this).$refs.messageFile;
        this.messageFileName = null;

        if (messageFile.files.length !== 0 && messageFile.files[0].name) {
            this.messageFileName = messageFile.files[0].name;
        }
    }

    public async submitForm() {
        FormHelper.removeFocus();
        this.validationErrors = [];
        this.isLoading = true;

        this.formData.supportTicketCode = this.supportTicketCode;

        let multipartData = new FormData();

        if ((<any>this).$refs.messageFile.files[0]) {
            multipartData.append("inputFile", (<any>this).$refs.messageFile.files[0]);
        }

        for (const key in this.formData) {
            if (Object.prototype.hasOwnProperty.call(this.formData, key)) {
                multipartData.append(key, this.formData[key]);
            }
        }

        try {
            await Axios.post(this.routes.MyBremboPartsSupport_SaveSupportTicketMessage, multipartData);

            this.isSuccess = true;

            window.location.href = window.location.href;
        } catch (error) {
            if (error.response && error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }

        this.isLoading = false;
    }

    public openForm() {
        this.isEdit = true;
    }

    public cancel() {
        this.isEdit = false;
    }

    public isValidationError(controlName: string): boolean {
        return FormHelper.isControlValidationError(controlName, this.validationErrors);
    }
};